export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_a28ccf7e-1414-48ac-9476-0c59cd840a1b/artifacts/jqqwvx8b_PHOTO-2026-09-29-19-11-28.jpeg";

export const IMAGES = {
  heroFlag: "https://images.unsplash.com/photo-1597058712635-3182d1eacc1e?w=1600&q=80&auto=format&fit=crop",
  aboutAccent: "/images/archana-1.jpg",
  gallery: [
    {
      url: "/images/archana-11.jpg",
      caption: "प्रेस वार्ता",
      alt: "प्रेस वार्ता को संबोधित करतीं डॉ. अर्चना गुप्ता",
    },
    {
      url: "/images/archana-5.jpg",
      caption: "पदभार ग्रहण समारोह",
      alt: "पंचकमल, पंचकूला में पदभार ग्रहण समारोह में डॉ. अर्चना गुप्ता",
    },
    {
      url: "/images/archana-9.jpg",
      caption: "मुख्यमंत्री के साथ",
      alt: "हरियाणा के मुख्यमंत्री श्री नायब सिंह सैनी के साथ डॉ. अर्चना गुप्ता",
    },
    {
      url: "/images/archana-4.jpg",
      caption: "जनसंवाद",
      alt: "कार्यकर्ताओं को संबोधित करतीं डॉ. अर्चना गुप्ता",
    },
    {
      url: "/images/archana-8.jpg",
      caption: "पार्टी नेताओं के साथ",
      alt: "भाजपा नेताओं के साथ डॉ. अर्चना गुप्ता",
    },
    {
      url: "/images/archana-1.jpg",
      caption: "कार्यकर्ता सम्मेलन",
      alt: "भाजपा कार्यक्रम में संबोधन देतीं डॉ. अर्चना गुप्ता",
    },
  ],
};

export const HARYANA_DISTRICTS = [
  "अम्बाला (Ambala)",
  "भिवानी (Bhiwani)",
  "चरखी दादरी (Charkhi Dadri)",
  "फरीदाबाद (Faridabad)",
  "फतेहाबाद (Fatehabad)",
  "गुरुग्राम (Gurugram)",
  "हिसार (Hisar)",
  "झज्जर (Jhajjar)",
  "जींद (Jind)",
  "कैथल (Kaithal)",
  "करनाल (Karnal)",
  "कुरुक्षेत्र (Kurukshetra)",
  "महेंद्रगढ़ (Mahendragarh)",
  "नूंह (Nuh)",
  "पलवल (Palwal)",
  "पंचकुला (Panchkula)",
  "पानीपत (Panipat)",
  "रेवाड़ी (Rewari)",
  "रोहतक (Rohtak)",
  "सिरसा (Sirsa)",
  "सोनीपत (Sonipat)",
  "यमुनानगर (Yamunanagar)",
];
